<script setup>

import { inject, ref, watch } from 'vue';
import { TypeNommage } from '@/scripts/global.js';
import { 
    getErreurNomNorme,
    getErreurValeurListeRequise } from '@/scripts/controlesSaisie.js';
import { apiAjouterDimension } from '@/services/ServiceModele.js';
    import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';
import SaisieTypeDonnee from '@/components/generiques/SaisieTypeDonnee.vue';
import SaisieModeEvaluation from '@/components/generiques/SaisieModeEvaluation.vue';

const { dimension } = defineProps({
    dimension: Object
});

const emit = defineEmits(['ajoutDimension', 'fermeture']);

const getTypeDonnee = inject('getTypeDonnee');
const appelerApiModifModele = inject('appelerApiModifModele');

const nouvelleDimension = ref(getDimensionInitiale());

watch(() => nouvelleDimension.value.nom, (nouveauNom, ancienNom) => {
    if (!nouvelleDimension.value.nomVariable || ancienNom && nouveauNom && nouvelleDimension.value.nomVariable === ancienNom[0].toLowerCase()) {
        nouvelleDimension.value.nomVariable = nouveauNom[0].toLowerCase();
    }
});



function getDimensionInitiale() {
    return {
        nom: dimension?.nom,
        nomVariable: dimension?.nomVariable,
        typeDonnee: getTypeDonnee(dimension?.typeDonnee),
        modeEvaluation: dimension?.modeEvaluation
    };    
}

function validerSaisie(dimension) {
    const erreurs = {};
    erreurs.nom = getErreurNomNorme(dimension.nom, TypeNommage.CLASSE);
    erreurs.nomVariable = getErreurNomNorme(dimension.nomVariable, TypeNommage.VARIABLE);
    erreurs.typeDonnee = getErreurValeurListeRequise(dimension.typeDonnee);
    erreurs.modeEvaluation = getErreurValeurListeRequise(dimension.modeEvaluation);
    return erreurs;
}

function validerFormulaire() {
    nouvelleDimension.value.validationFormulaire = true;
}

function ajouterDimension() {
	appelerApiModifModele(apiAjouterDimension, nouvelleDimension.value, (reponseOK) => {
		if (reponseOK) {
            emit('fermeture');
            emit('ajoutDimension', nouvelleDimension.value.nom)
		}
	});
}

function gererFermeture(visible) {
    if (!visible) {
        emit('fermeture');
    }
}

</script>

<template>
    <Dialog 
        :visible="true" 
        modal 
        header="Ajout d'une dimension"
        @update:visible="gererFermeture">
            <Formulaire
                :objet="nouvelleDimension"
                :fonction-validation-saisie="validerSaisie"
                @validation="ajouterDimension">
                <label class="intitule">Nom :</label>
                <SaisieTexte 
                    v-model:valeur="nouvelleDimension.nom" 
                    :id-erreur="'nom'" 
                    :autofocus="true" />
                <label class="intitule">Nom de la variable :</label>
                <SaisieTexte 
                    v-model:valeur="nouvelleDimension.nomVariable" 
                    :id-erreur="'nomVariable'" />
                <label class="intitule">Type :</label>
                <SaisieTypeDonnee 
                    v-model:valeur="nouvelleDimension.typeDonnee" 
                    :id-erreur="'typeDonnee'"
                    :proposer-types-objets="false" 
                    :desactive="false" />
                <label class="intitule">Mode :</label>
                <SaisieModeEvaluation v-model:valeur="nouvelleDimension.modeEvaluation" :id-erreur="'modeEvaluation'" />
            </Formulaire>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="false"
                    @click="validerFormulaire()"/>
            </template>
    </Dialog>
</template>

<style scoped>

</style>